__turbopack_context__.v({
  "icon": "hXSIHG_icon",
  "scrollToTopButton": "hXSIHG_scrollToTopButton",
});
